<ng-template #noPermission>
    <p>Sorry you don't have permission to access this page.</p>
</ng-template>

<div class="main" *ngIf="hasAccess; else noPermission">
    <div class="status-message status-message-danger" *ngIf="errorMessage !== '' && errorMessage !== null">
        <span class="display-message"> {{errorMessage}} </span>
        <span class="close-btn" (click)="resetErrorMessage()"><mat-icon>cancel</mat-icon></span>
    </div>

    <div class="status-message status-message-success" *ngIf="successMessage !== '' && successMessage !== null">
        <span class="display-message"> {{successMessage}} </span>
        <span class="close-btn" (click)="resetSuccessMessage()"><mat-icon>cancel</mat-icon></span>
    </div>

    <h4>Manage Pop-Ups</h4>

    <div class="add-rule-container">
        <button class="add-rule-button" (click)="addNewRule()">Add New Rule</button>
    </div>

    <ng-container *ngIf="loading$ | async">
        <div class="spinner-container">
            <div class="spinner">
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
        </div>
    </ng-container>

    <div class="table-container" [hidden]="(fraudRules$ | async)?.length <= 0">
        <mat-table [dataSource]="dataSource$ | async" class="mat-table">
            <ng-container matColumnDef="ruleName">
                <mat-header-cell *matHeaderCellDef class="fixed-width-column"
                    >{{ displayedColumns['ruleName'] }}</mat-header-cell
                >
                <mat-cell *matCellDef="let rule" class="fixed-width-column">
                    <span>{{ rule.ruleName }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ruleType">
                <mat-header-cell *matHeaderCellDef class="rule-type-header"
                    >{{ displayedColumns['ruleType'] }}</mat-header-cell
                >
                <mat-cell *matCellDef="let rule" class="rule-type-cell">
                    <span>{{ rule.ruleType }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="thresholdValue">
                <mat-header-cell *matHeaderCellDef>{{ displayedColumns['thresholdValue'] }}</mat-header-cell>
                <mat-cell *matCellDef="let rule">
                    <span>{{ rule.thresholdValue }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>{{ displayedColumns['status'] }}</mat-header-cell>
                <mat-cell *matCellDef="let rule">
                    <span>{{ rule.status }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef class="fixed-width-column">Actions</mat-header-cell>
                <mat-cell *matCellDef="let rule" class="actions fixed-width-column">
                    <button class="states edit-button" (click)="editRule(rule.originalRuleObject)">Edit</button>
                    <button
                        class="states"
                        [ngClass]="rule.isEnabled ? 'disable-button' : 'enable-button'"
                        (click)="toggleRuleStatus(rule.originalRuleObject)"
                    >
                        {{ rule.isEnabled ? 'Disable' : 'Enable' }}
                    </button>
                    <button class="states delete-button" (click)="deleteRule(rule.originalRuleObject)">Delete</button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumnsKeys"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumnsKeys;"></mat-row>
        </mat-table>

        <mat-paginator
            #paginator
            [pageSize]="pageSize"
            [pageIndex]="currentPage"
            [pageSizeOptions]="pageSizeOptions"
            showFirstLastButtons
        >
        </mat-paginator>
    </div>

    <div class="no-data" *ngIf="(fraudRules$ | async)?.length === 0">
        <p>No fraud pop-ups rules have been created yet</p>
    </div>
</div>
